$(->
  if location.hash && location.hash.length > 0
    activeTab = $('a[href="' + location.hash + '"]')
    activeTab && activeTab.tab('show')
)
